const resolvePlayerName = (name) => {
  if (!name) return ''
  return name.replace(/^X\s/i, 'Player ')
}

export const getMarketTitle = (marketInfo) => {
  if (!marketInfo) return ''
  if (marketInfo.presentationType === 11) {
    return resolvePlayerName(marketInfo.name)
  }
  return marketInfo.description
}

export const getComboMarketTitle = (marketInfo) => {
  if (!marketInfo) return ''
  if (marketInfo.presentationType === 11) {
    return resolvePlayerName(marketInfo.name)
  }
  return marketInfo.groupName
}
